"use client";

import { useEffect } from "react";
import { registerServiceWorker } from "@lib/pwa/registerServiceWorker";

export function ServiceWorkerRegistrar() {
  useEffect(() => {
    void registerServiceWorker();
  }, []);
  return null;
}
